import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./maintenance-mode.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./maintenance-mode.component.scss?ngResource";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Router } from "@angular/router";
import { UserInformationService } from "../../services/user/user-information.service";
import { SystemSettingService } from "../../services/system-setting/system-setting.service";
import { DashboardRoutingConstants } from "../../../core/dashboard/dashboard-routing.constants";
let MaintenanceModeComponent = class MaintenanceModeComponent {
    userInformationService;
    systemSettingService;
    router;
    isSysAdmin = false;
    isSuperAdmin = false;
    canContinue = false;
    continueBtnText = "Continue";
    constructor(userInformationService, systemSettingService, router) {
        this.userInformationService = userInformationService;
        this.systemSettingService = systemSettingService;
        this.router = router;
        this.isSysAdmin = this.userInformationService.authenticatedUser.isSysAdmin;
        this.isSuperAdmin = this.userInformationService.isAnyOrganisationSuperAdmin();
        this.canContinue = this.isSysAdmin || this.isSuperAdmin;
    }
    continueToApp() {
        this.systemSettingService.setMaintenanceAcknowledged();
        this.router.navigate([DashboardRoutingConstants.MODULES_ROUTE]);
    }
    static ctorParameters = () => [
        { type: UserInformationService },
        { type: SystemSettingService },
        { type: Router }
    ];
};
MaintenanceModeComponent = __decorate([
    Component({
        selector: "app-maintenance-mode",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        standalone: false,
        styles: [__NG_CLI_RESOURCE__1]
    })
], MaintenanceModeComponent);
export { MaintenanceModeComponent };
